/**
 * Helpers de navegação para abrir o detalhe de um processo a partir de
 * qualquer lugar do app via query param `?process=<id>` na rota raiz.
 *
 * Centralizar aqui garante que notificações, popover, deep links e quaisquer
 * outras origens usem o mesmo formato de URL.
 */

export const PROCESS_QUERY_PARAM = "process";

/** Gera o href que abre o detalhe de um processo na home. */
export function openProcessHref(processId: string): string {
  return `/?${PROCESS_QUERY_PARAM}=${encodeURIComponent(processId)}`;
}

/**
 * Extrai um eventual `?process=<id>` de uma URL/route arbitrária.
 * Útil para rotas que não renderizam o detalhe e precisam reencaminhar
 * o usuário para a home.
 */
export function extractProcessParam(search: string): string | null {
  const params = new URLSearchParams(search);
  return params.get(PROCESS_QUERY_PARAM);
}
